import axios from "axios";
import url from "../config/urlServiceConfig";

const kpiAPI = {
  getAll: () => axios.get(url.kpi),
  getById: (id) => axios.get(`${url.kpi}/${id}`),
  create: (body) => axios.post(url.kpi, body),
  update: (body) => axios.put(url.kpi, body),
  delete: (id) => axios.delete(`${url.kpi}/${id}`),
  lock: (id) => axios.put(`${url.kpi}/lockKPI/${id}`),
  unlock: (id) => axios.put(`${url.kpi}/unLockKPI/${id}`),
  getComments: (id) => axios.get(`${url.kpi}/Comment/${id}`),
  createComment: (body) => axios.post(`${url.kpi}/Comment`, body),
  updateComment: (body) => axios.put(`${url.kpi}/Comment`, body),
  deleteComment: (id) => axios.delete(`${url.kpi}/Comment/${id}`),
  getKPIAttachments: (id) => axios.get(`${url.attachment}/${url.kpi}/${id}`),
  calculateUpdateValue: (body) => axios.post("/CalculateParameterValue", body),
  validateFormula: (body) => axios.post("/ValidateFormula", body),
  getHistoricalInformation: (id) =>
    axios.get(`/HistoricalInformation/KPI/${id}`),
  getMeasures: (id, frequency) =>
    axios.get(`${url.kpi}/Timeline/${id}/${frequency}`),
  checkIsOrderValid: (order, strategyID, params) =>
    axios.get(`${url.kpi}/ValidateOrder/${order}/${strategyID}`, { params }),
  checkIsCodeValid: (strategyID, params) =>
    axios.get(`${url.kpi}/ValidateCode/${strategyID}`, { params }),
  getChangeRequests: (id) => axios.get(`ChangeRequest/${url.kpi}/${id}`),
  changeKPIRequest: (body) => axios.post(`SaveKPIChangeRequest`, body),
  generateMeasures: (params) =>
    axios.post(`${url.kpi}/GenerateMeasures`, {}, { params }),
  getChangeRequestMeasures: (id) =>
    axios.get(`${url.kpi}/ChangeRequestMeasures/${id}`),
  getValidStatusUpdate: (kpiId, measureId, params) =>
    axios.get(`${url.kpi}/ValidStatusUpdate/${kpiId}/${measureId}`, { params })
};

export default kpiAPI;
